import React from 'react';
import { useScrollReveal } from '../hooks/useScrollReveal';
export function StatsBar() {
  const revealRef = useScrollReveal();
  const stats = [{
    number: '+500',
    label: 'Lectores transformados'
  }, {
    number: '4.9★',
    label: 'Valoración promedio'
  }, {
    number: '100+',
    label: 'Páginas de protocolo'
  }, {
    number: '7 días',
    label: 'Garantía total'
  }];
  return <section className="bg-brand-gold w-full relative z-20" data-id="element-199">
      <div ref={revealRef} className="max-w-7xl mx-auto grid grid-cols-2 md:grid-cols-4 reveal" data-id="element-200">
        {stats.map((stat, i) => <div key={i} className="text-center py-8 px-4 border-b md:border-b-0 md:border-r border-brand-ink/10 last:border-0" data-id="element-201">
            <div className="font-display text-[48px] text-brand-ink font-normal leading-none mb-1" data-id="element-202">
              {stat.number}
            </div>
            <div className="font-body text-[12px] text-brand-ink/70 tracking-[0.04em] uppercase" data-id="element-203">
              {stat.label}
            </div>
          </div>)}
      </div>
    </section>;
}